<style scoped>

  .bor {
    border: 3px dotted pink;
  }

  .cont1 {
    display: flex;
    margin-top: 10px;
  }

  @media (max-width: 1200px) {
    .cont1 {
      flex-direction: column-reverse;
    }
  }

  #boostergrid {
    display: grid;
    grid-template-areas:
    "tv tv"
    "list panel";
    grid-gap: 10px;
    grid-template-columns: 1fr 35%;
  }

  @media all and (max-width: 1000px) {
    #boostergrid {
      grid-template-areas:
        "tv"
        "panel"
        "list";
      grid-template-columns: 1fr;
    }
  }

  #boostertv {
    grid-area: tv;
  }
  #boosterlist {
    grid-area: list;
  }
  #boosterpanel {
    grid-area: panel;
  }

</style>
<template>
  <div id="boostergrid">
    <FastbotTV id="boostertv"/>
    <FastbotList id="boosterlist"/>
    <FastbotPanel id="boosterpanel"/>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import FastbotPanel from '@/components/MainPage/Fastbot/FastbotPanel.vue'
import FastbotList from '@/components/MainPage/Fastbot/FastbotList.vue'
import FastbotTV from '@/components/MainPage/Fastbot/FastbotTV.vue'
import fastbot from '@/services/fastbot'

@Component({
  components: {
    FastbotPanel,
    FastbotList,
    FastbotTV
  }
})
export default class Fastbot extends Vue {
  @Prop() private msg!: string

  updateFastbotSymbolsInterval?: number

  async mounted () {
    // console.log('Fastbot mounted')
    fastbot.updateFastbotSymbols()
    this.updateFastbotSymbolsInterval = setInterval(() => {
      fastbot.updateFastbotSymbols()
    }, 300 * 1000)
  }

  destroyed () {
    clearInterval(this.updateFastbotSymbolsInterval)
  }
}
</script>
